import React, { memo } from 'react';
import window from 'global';
import { ReactMarkdownDisplay } from '../../PageElements/ReactMarkdownDisplay';
import { FeedbackContainer } from '../../Feedback';
import { IntersectionSubscriber } from '../../SectionIntersectionDetection/IntersectionSubscriber';
import { getMarkdownPath, getMdName } from '../../../../utils/markdownUtils';
import MarkdownTableOfContent from './MarkdownTableOfContent';
import { MarkdownSourceLinkButton } from './MarkdownSourceLinkButton';
import { getCompressedMdContent } from '../../../../utils/changelogPimple/utils';
import { isClientSide } from '../../../../common/utils';
import style from './GuideMarkdownDisplay.scss';

interface GuideMarkdownDisplayProps {
  mdFile: MdFile;
  prefix: string;
}

interface MdFile {
  id: string;
  name: string;
  displayName?: string;
  content: string;
  isChangelog?: boolean;
  src?: string;
  urlFormat?: string;
}

export default function GuideMarkdownDisplay({
  mdFile,
  prefix,
}: GuideMarkdownDisplayProps) {
  const mdFileName = getMdName(mdFile);
  const markdownPath = getMarkdownPath(mdFileName, prefix);
  const additionalProps = {};

  if (mdFile?.isChangelog) {
    additionalProps['data-changelog-content'] = getCompressedMdContent(
      mdFile?.content,
    );
  }

  return (
    <article
      data-hook={`top-level-md-guide-${mdFileName}`}
      className={style.wrapper}
    >
      <section className={style.mdDisplay}>
        <IntersectionSubscriber
          tagName="div"
          className={style.intersectionSubscriber}
          id={markdownPath}
          {...additionalProps}
        />
        <MarkdownSourceLinkButton mdFileSrc={mdFile.src} />
        <ReactMarkdownDisplay
          markdown={mdFile.content}
          mdName={mdFileName}
          mdUrlFormat={mdFile.urlFormat}
          prefix={prefix}
        />
        <FeedbackContainer memberId={markdownPath} />
      </section>
      <MarkdownTableOfContent
        markdown={mdFile?.content}
        mdName={mdFileName}
        mdUrlFormat={mdFile.urlFormat}
        prefix={prefix}
      />
    </article>
  );
}
